import { put, takeEvery, select } from 'redux-saga/effects';
import Parse from "../../Utils/index"
import { getAvailableSlotSuccess, getAvailableSlotFailure, scheduleAppointmentConsts } from "./actions"
import { showNotification } from "react-admin"
import moment from "moment"


export function* getAvailableSlotsSaga(action) {
    const selectedMentor = yield select(state => state.appointment.selectedMentor)
    const payload = action.payload
    try {
        const MentorTimeSlot = Parse.Object.extend('MentorTimeSlot');
        const ScheduleQuery = new Parse.Query(MentorTimeSlot);
        ScheduleQuery.greaterThan('slotTime', moment(payload.selectedDate,"YYYY-MM-DD").startOf('day').toDate())
        ScheduleQuery.lessThan('slotTime', moment(payload.selectedDate,"YYYY-MM-DD").startOf('day').add(1, 'days').toDate())
        ScheduleQuery.equalTo('user', { "__type": "Pointer", "className": "_User", "objectId": selectedMentor })
        const availableSots = yield ScheduleQuery.find()
        yield put(getAvailableSlotSuccess(availableSots))

    } catch (e) {
        yield put(getAvailableSlotFailure(e))
        showNotification("Could not fetch available slots", 'warning')
    }
}


export default function* main() {
    yield takeEvery(scheduleAppointmentConsts.GET_AVAILABLE_SLOTS, getAvailableSlotsSaga);
}
